import React from 'react';
import { Star, MapPin, Clock } from 'lucide-react';
import { Store } from '../types';
interface StoreCardProps {
  store: Store;
  onClick: () => void;
  variant?: 'default' | 'compact' | 'featured';
  showCheckIn?: boolean;
  onCheckIn?: (e: React.MouseEvent) => void;
}
export function StoreCard({
  store,
  onClick,
  variant = 'default',
  showCheckIn,
  onCheckIn
}: StoreCardProps) {
  if (variant === 'compact') {
    return <div onClick={onClick} className="flex-shrink-0 w-40 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden active:scale-95 transition-transform cursor-pointer" data-id="element-709">
        <div className="h-24 bg-gray-200 relative" data-id="element-710">
          <img src={store.image} alt={store.name} className="w-full h-full object-cover" data-id="element-711" />
          <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-1.5 py-0.5 rounded-lg flex items-center gap-1 shadow-sm" data-id="element-712">
            <Star size={10} className="text-yellow-500 fill-yellow-500" data-id="element-713" />
            <span className="text-[10px] font-bold" data-id="element-714">{store.rating}</span>
          </div>
        </div>
        <div className="p-3" data-id="element-715">
          <h3 className="font-bold text-gray-900 text-sm truncate" data-id="element-716">
            {store.name}
          </h3>
          <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1" data-id="element-717">
            <MapPin size={10} data-id="element-718" /> {store.distance}
          </p>
        </div>
      </div>;
  }
  return <div onClick={onClick} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden active:scale-[0.98] transition-all cursor-pointer group" data-id="element-719">
      <div className="h-32 bg-gray-200 relative overflow-hidden" data-id="element-720">
        <img src={store.image} alt={store.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-721" />
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg flex items-center gap-1 shadow-sm" data-id="element-722">
          <Star size={12} className="text-yellow-500 fill-yellow-500" data-id="element-723" />
          <span className="text-xs font-bold" data-id="element-724">{store.rating}</span>
        </div>
        {store.tags[0] && <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm px-2 py-1 rounded-lg" data-id="element-725">
            <span className="text-[10px] font-medium text-white" data-id="element-726">
              {store.tags[0]}
            </span>
          </div>}
      </div>
      <div className="p-4" data-id="element-727">
        <div className="flex justify-between items-start mb-2" data-id="element-728">
          <div data-id="element-729">
            <h3 className="font-bold text-gray-900 text-lg leading-tight" data-id="element-730">
              {store.name}
            </h3>
            <div className="flex items-center gap-3 mt-1 text-sm text-gray-500" data-id="element-731">
              <span className="flex items-center gap-1" data-id="element-732">
                <MapPin size={12} data-id="element-733" /> {store.distance}
              </span>
              <span className="flex items-center gap-1" data-id="element-734">
                <Clock size={12} data-id="element-735" /> {store.hours.split('-')[0]}
              </span>
            </div>
          </div>
        </div>

        {showCheckIn && <button onClick={e => {
        e.stopPropagation();
        onCheckIn?.(e);
      }} className="mt-3 w-full py-2 bg-purple-50 text-purple-700 font-semibold text-sm rounded-xl hover:bg-purple-100 transition-colors" data-id="element-736">
            Check In
          </button>}
      </div>
    </div>;
}